module.exports = __webpack_public_path__ + "img/boosts.84250160.png";